import { connect } from 'react-redux'
import View from './index'
import {stdAction, ACTIONS} from '../../actions/Actions'

const mapStateToProps = (state, ownProps) => {

    return {
	credits_logs: state.credits_logs,
	current_user: (state.users.current != null  ? state.users.current.info : {})
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {

    return {
	getCreditsLogs: (params) => dispatch(stdAction(ACTIONS.credits_logs.index, params))
    }
}

const Container = connect(
    mapStateToProps,
    mapDispatchToProps
)(View)

export default Container
